var importTaxesInfoModalClose = function importTaxesInfoModalClose() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:compra-internacional',
    eventLabel: 'entendi'
  };
};
export default importTaxesInfoModalClose;